export const CLEAR_STATE = 'SHIPPING_USER.CREATE.CLEAR_STATE';
export const RESET_ERROR = "SHIPPING_USER.CREATE.RESET_ERROR";
